import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';
import { env } from 'env';
import Cookies from 'js-cookie';

export const SaveSurveyForm = async (
  frmInfo,
  data,
  navigate
) => {
  const user =
    Cookies.get('user') && JSON.parse(Cookies.get('user'));

  return Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_SAVE_SURVEY_DATA}`,
    false,
    {
      idElsFormPatient: 0,
      formID: frmInfo.formID,
      patientFormID: 0,
      idPatient: frmInfo.patientID,
      idConfer: frmInfo.idConfer,
      AlloEdit: true,
      idType: frmInfo.idType,
      idCartablPatient: 0,
      idPerson: 1,
      listDetail: data,
    }
  ).then((response) => {
    if (response.data.resCode === 1) {
      SwalAlert(
        'success',
        response.data.resMessage,
        false
      ).then(() => {
        navigate('/main');
      });
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
  });
};
